import { FormattedMessage } from "@/i18n/i18n-client";
import Flex from "@/shared/globals/UiElements/Flex";
import { CouponIcon } from "@/assets/Icons/CouponIcon";
import { PriceBase } from "@/components/Price/Price";
import { Badge } from "@/shared/globals/UiElements/Badge";
import { DiscountBreakdownProps, TemplateElement } from "../../types";

const DiscountsBreakdown: TemplateElement<DiscountBreakdownProps> = ({
  totalDiscounts,
  aggregateDiscount,
}) => {
  return (
    <Flex
      column
      fullWidth
      justifyContent="space-between"
      alignItems="flex-start"
    >
      <Flex fullWidth justifyContent="space-between">
        <span className="text-text-sm text-gray-600">
          <FormattedMessage defaultMessage="Discount" id="28C0Aj" />
        </span>
        <span className="text-text-sm text-success-500">
          -
          <PriceBase
            money={aggregateDiscount}
            className="text-text-sm text-success-500"
          />
        </span>
      </Flex>
      {!!aggregateDiscount?.amount && totalDiscounts && (
        <Flex column fullWidth justifyContent="space-between" spacing="s">
          {Array.from(totalDiscounts.keys()).map((discount, index) => {
            if (totalDiscounts.get(discount)!.amount > 0)
              return (
                <Flex
                  key={index}
                  spacing="s"
                  fullWidth
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Badge
                    type="white"
                    label={
                      <Flex
                        alignItems="center"
                        justifyContent="space-between"
                        spacing="xs"
                      >
                        <CouponIcon />
                        {discount}
                      </Flex>
                    }
                  />
                  <span className="text-text-sm text-success-500">
                    -
                    <PriceBase money={totalDiscounts.get(discount)} />
                  </span>
                </Flex>
              );
            return null;
          })}
        </Flex>
      )}
    </Flex>
  );
};

export default DiscountsBreakdown;
